export const state = {
  groceryList: [
    {
      color: '#F36CF3',
      groceryItems: [
        {
          checkedAt: null,
          count: '1 tsp',
          currentMeals: [
            {
              dishId: 2990997,
              recipeId: 3619,
            },
          ],
          id: 16362600,
          ingredient: {
            brands: [],
            category: {
              color: '#F36CF3',
              id: 7,
              name: 'Fruits',
              order: 1,
              parentCategory: 'Fresh',
            },
            description: null,
            id: 5742,
            imageurl: null,
            ingredientCategoryId: 7,
            name: 'lemon',
            type: null,
          },
          ingredientItemIds: [{ 0: 16362600 }],
          isChecked: false,
          isCustom: false,
          isStaple: false,
          isStapleAdded: false,
          name: 'lemon',
        },
      ],
      id: 6,
      imageUrl: '',
      name: 'Fruits',
      order: 1,
      parentCategory: 'Fresh',
      stapleItems: [],
    },
    {
      color: '#F36CF3',
      groceryItems: [
        {
          checkedAt: null,
          count: '1 tsp',
          currentMeals: [
            {
              dishId: 2990997,
              recipeId: 3619,
            },
          ],
          id: 16362600,
          ingredient: {
            brands: [],
            category: {
              color: '#F36CF3',
              id: 7,
              name: 'Fruits',
              order: 1,
              parentCategory: 'Fresh',
            },
            description: null,
            id: 5742,
            imageurl: null,
            ingredientCategoryId: 7,
            name: 'lemon',
            type: null,
          },
          ingredientItemIds: [{ 0: 16362600 }],
          isChecked: false,
          isCustom: false,
          isStaple: false,
          isStapleAdded: false,
          name: 'lemon',
        },
      ],
      id: 7,
      imageUrl: '',
      name: 'Veggies',
      order: 1,
      parentCategory: 'Fresh',
      stapleItems: [],
    },
  ],
  selectedItem: null,
  isListActive: false,
};

export const getters = {};

export const mutations = {
  setGroceryList(state, value) {
    state.groceryList = value;
  },
  setDeleteGroceryItem(state, value) {},
  setUpdateGroceryItem(state, value) {},
  setNewGroceryItem(state, value) {},
  setSelectedItem(state, value) {
    state.selectedItem = value;
  },
  setToggleList(state, value) {
    state.isListActive = !state.isListActive;
  },
};

export const actions = {};
